export const changeRequestBrands = {
  GIH: 'GIH',
  BSBI: 'Berlin School of Business and Innovation'
}
